import { useUpdateLocationMonitoringDisarmWindow } from '@hakimo-ui/hakimo/data-access';
import { DisarmWindowModal } from '@hakimo-ui/hakimo/feature-shared';
import { SiteDisarmWindow } from '@hakimo-ui/hakimo/types';
import { toast } from '@hakimo-ui/hakimo/util';

interface Props {
  locationId: string;
  onClose: () => void;
  siteDisarmWindow?: SiteDisarmWindow;
  isRelevantWindow: boolean;
  timezone: string;
}

function UpdateMonitoringDisarmModal({
  locationId,
  onClose,
  siteDisarmWindow,
  isRelevantWindow,
  timezone,
}: Props) {
  const effectiveTimezone = isRelevantWindow
    ? siteDisarmWindow?.timezone || timezone
    : timezone;
  const mutation = useUpdateLocationMonitoringDisarmWindow(locationId, () => {
    toast('Monitoring Disarm window successfully updated');
    onClose();
  });

  return (
    <DisarmWindowModal
      onClose={onClose}
      onSubmit={(payload) =>
        payload.discard
          ? mutation.mutate({
              startTimestamp: 0,
              endTimestamp: 1,
              timezone: payload.timezone,
            })
          : mutation.mutate({
              startTimestamp: payload.startTimestamp,
              endTimestamp: payload.endTimestamp,
              timezone: payload.timezone,
            })
      }
      mutation={{
        isLoading: mutation.isLoading,
        error: mutation.error?.message,
      }}
      timezone={effectiveTimezone}
      existingWindow={
        siteDisarmWindow
          ? {
              startTime: siteDisarmWindow.startTimestamp,
              endTime: siteDisarmWindow.endTimestamp,
              timezone: siteDisarmWindow.timezone,
            }
          : undefined
      }
      infoMessage="Temporarily disarm monitoring for the specified period. Otherwise, monitoring will follow the site monitoring schedule."
      allowTimezoneChange={true}
    />
  );
}

export default UpdateMonitoringDisarmModal;
